import { z } from "zod";
import { apiListSchema } from "./list";
import { HotelRoomDtoSchema } from "./hotel-room";

//? DTO
export const CreateHotelRoomPriceDtoSchema = z.object({
  Type: z.string().nullish(),
  Price: z.number().nullish(),
  StartDate: z.string().nullish(),
  EndDate: z.string().nullish(),
  HotelRoomId: z.number().nullish(),
});
export type CreateHotelRoomPriceDto = z.infer<
  typeof CreateHotelRoomPriceDtoSchema
>;

export const HotelRoomPriceDtoSchema = CreateHotelRoomPriceDtoSchema.extend({
  Id: z.number(),
  HotelRoom: HotelRoomDtoSchema.nullish(),
});
export type HotelRoomPriceDto = z.infer<typeof HotelRoomPriceDtoSchema>;

export const hotelRoomPriceDtoListSchema = apiListSchema(
  HotelRoomPriceDtoSchema,
);
//? Model

export enum HotelRoomType {
  Twin = "Twin",
  Double = "Double",
  DSU = "DSU",
  Triple = "Triple",
  Other = "Other",
}

export const hotelRoomTypeEnumToNumber: Record<HotelRoomType, number> = {
  Twin: 0,
  Double: 1,
  DSU: 2,
  Triple: 3,
  Other: 4,
};

export const hotelRoomTypeNumToEnum = Object.entries(
  hotelRoomTypeEnumToNumber,
).reduce((acc, [key, value]) => ({ ...acc, [value]: key }), {}) as Record<
  number,
  HotelRoomType
>;

export const HotelRoomTypesAsArray = Object.values(HotelRoomType);

export const CreateHotelRoomPriceSchema = z.object({
  type: z.string().nullish(),
  price: z.number().nullish(),
  startDate: z.date().nullish(),
  endDate: z.date().nullish(),
  hotelRoomId: z.number().nullish(),
});

export const HotelRoomPriceSchema = CreateHotelRoomPriceSchema.extend({
  id: z.string().min(1),
});

export type CreateHotelRoomPrice = z.infer<typeof CreateHotelRoomPriceSchema>;

export type HotelRoomPrice = z.infer<typeof HotelRoomPriceSchema>;

//? Mappers

export function hotelRoomPriceFromDto(dto: HotelRoomPriceDto): HotelRoomPrice {
  return {
    id: dto.Id.toString(),
    type: dto.Type,
    hotelRoomId: dto.HotelRoomId,
    price: dto.Price,
    startDate: dto.StartDate ? new Date(dto.StartDate) : undefined,
    endDate: dto.EndDate ? new Date(dto.EndDate) : undefined,
  };
}

export function hotelRoomPriceToDto(dto: HotelRoomPrice): HotelRoomPriceDto {
  return {
    Id: Number.parseInt(dto.id),
    ...createHotelRoomPriceToDto(dto),
  };
}

export function createHotelRoomPriceToDto(
  dto: CreateHotelRoomPrice,
): CreateHotelRoomPriceDto {
  return {
    EndDate: dto.endDate?.toDateString(),
    StartDate: dto.startDate?.toDateString(),
    HotelRoomId: dto.hotelRoomId,
    Price: dto.price,
    Type: dto.type,
  };
}
